import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#111111] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-white/10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/85d9afa4-e183-4d88-8b8b-0a9df5b414c2.png"
              alt="GERPAT Logo"
              className="h-14 w-auto object-contain mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-5">
              Empresa especializada en servicios de grúa, transporte logístico y compra-venta de vehículos en las provincias de Lleida y Huesca.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#FF6B35] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#FF6B35] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#FF6B35] transition-colors cursor-pointer">
                <i className="ri-whatsapp-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Servicios */}
          <div>
            <h4 className="text-[#FF6B35] text-xs font-bold uppercase tracking-widest mb-5">
              <a href="#servicios">Servicios</a>
            </h4>
            <ul className="space-y-2.5">
              {["Grúa para turismos", "Grúa para vehículos pesados", "Transporte de maquinaria", "Asistencia en carretera", "Traslado de vehículos"].map((s) => (
                <li key={s}>
                  <Link to="/servicios" className="text-gray-400 text-sm hover:text-[#FF6B35] transition-colors cursor-pointer">
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Empresa */}
          <div>
            <h4 className="text-[#FF6B35] text-xs font-bold uppercase tracking-widest mb-5">
              <a href="#empresa">Empresa</a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: "Sobre nosotros", path: "/sobre-nosotros" },
                { label: "Compra-venta", path: "/vehiculos" },
                { label: "Contacto", path: "/contacto" },
                { label: "FAQ", path: "/faq" },
              ].map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="text-gray-400 text-sm hover:text-[#FF6B35] transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="text-[#FF6B35] text-xs font-bold uppercase tracking-widest mb-5">
              <a href="#contacto">Contacto</a>
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-[#FF6B35] text-base"></i>
                </div>
                <span className="text-gray-400 text-sm">Partida San Juan S/N<br />Castillonroy 22572, Huesca</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-[#FF6B35] text-base"></i>
                </div>
                <a href="tel:+34638250936" className="text-gray-400 text-sm hover:text-[#FF6B35] transition-colors cursor-pointer">+34 638 25 09 36</a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-[#FF6B35] text-base"></i>
                </div>
                <a href="mailto:facturaciongerpat@gmail.com" className="text-gray-400 text-sm hover:text-[#FF6B35] transition-colors cursor-pointer">facturaciongerpat@gmail.com</a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-time-line text-[#FF6B35] text-base"></i>
                </div>
                <span className="text-gray-400 text-sm">Lleida y Huesca</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-xs text-center sm:text-left">
            © 2025 Gerpat Logística i Serveis S.L. · CIF B16976326 · Todos los derechos reservados
          </p>
          <div className="flex gap-4">
            <a href="#" className="text-gray-500 text-xs hover:text-gray-300 transition-colors cursor-pointer">Política de privacidad</a>
            <a href="#" className="text-gray-500 text-xs hover:text-gray-300 transition-colors cursor-pointer">Aviso legal</a>
            <a href="#" className="text-gray-500 text-xs hover:text-gray-300 transition-colors cursor-pointer">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
